<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item v-if="!param.ismember">
        <wcinput :option="{placeholder:'请输入vip名称',clearable:true,ischange:true,isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item v-if="param.ismember">
        <div @click="searchmemberinfos">
        <wcinput :option="{placeholder:'选择会员',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true,clearable:true}" 
            :value="searchmember.membername"
            @finish="(val)=> {}"
        />
        </div>
        </el-form-item>

        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item v-if="param.ismember">
        <wcbutton :option="{title:'重置'}" 
            @finish="(val)=> {
                this.searchmember.memberid='';
                this.searchmember.membername='';
                this.param.memberid='';
                this.param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
        <el-form-item v-if="!param.ismember">
        <wcbutton :option="{title:'新增vip'}" @finish="$parent.JUMPVIEW({name:'EsAddVip',param:{}});"/>
        </el-form-item>
        <el-form-item style="position:absolute;right:0;">
        <div class="TTL-switch" style="display:inline-flex;align-items:center;height:60px;">
        <el-switch v-model="param.ismember" active-text="按付费会员搜索" 
            @change="(val)=>{
                this.param.key='';
                this.param.memberid='';
                this.param.ischange=true;
                GetList();
            }" 
        />
        </div>
        </el-form-item>
    </el-form>
</div>


<!-- vip设置 -->
<div class="TTL-table top20" v-if="!param.ismember">
    <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="name" label="vip名称" align="center" min-width="150">
            <template #default="scope">
                <div class="TTL-username" @click="$parent.JUMPVIEW({name:'EsVipDetail',param:{id:scope.row.id}})">{{scope.row.name}}</div>
            </template>
        </el-table-column>
        <el-table-column label="时效" align="center" min-width="150">
            <template #default="scope">
                <div>{{scope.row.nums+scope.row.type}}</div>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="baseprice" label="原始金额" align="center" min-width="150" /> -->
        <el-table-column prop="price" label="金额" align="center" min-width="150" />
        <el-table-column prop="orders" label="充值次数" align="center" min-width="150" />
        <el-table-column prop="orderprice" label="充值金额" align="center" min-width="150" />
        <el-table-column label="活动时间" align="center" min-width="280">
            <template #default="scope">
                <div class="active-time" v-if="scope.row.active_begintime!=''">
                <span>{{scope.row.active_begintime+' ~ '+scope.row.active_endtime}}</span>
                <span>{{scope.row.activestatusname}}</span>
                </div>
                <div class="active-time" v-if="scope.row.active_begintime==''">/</div>
            </template>
        </el-table-column>
        <el-table-column prop="inputtime" label="添加时间" align="center" min-width="150" />
        <el-table-column label="上/下架" align="center" min-width="150">
            <template #default="scope">
                <el-switch v-model="scope.row.isshow" @change="ChangeShow(scope.row)" />
            </template>
        </el-table-column>
        <el-table-column label="排序" align="center" min-width="150">
            <template #default="scope">
                <div class="TTL-info">
                <wcinput :option="{placeholder:'排序',type:'input',ischange:true,width:'80px'}" 
                    :value="scope.row.sort"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            scope.row.sort=val.value;
                            ChangeSort(scope.row.id,scope.row.sort);
                        }
                    }"
                />
                </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="180" fixed="right">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'修改',type:'del'}" @finish="(val)=> {
                    this.$parent.JUMPVIEW({name:'EsEditVip',param:{id:scope.row.id}})
                }"/>
                <wcbutton :option="{title:'删除',type:'del'}" class="left10" @finish="(val)=> {
                    this.delVip(scope.row.id);
                }"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<!-- vip充值记录 -->
<div class="TTL-table top20" v-if="param.ismember">
    <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column type="selection" />
        <el-table-column prop="name" label="会员名称" align="center">
            <template #default="scope">
                <wcimage :option="{size:'middle'}" :value="scope.row.memberavar" />
            </template>
        </el-table-column>
        <el-table-column label="会员名称" align="center">
            <template #default="scope">
                <div>{{scope.row.membername}}</div>
            </template>
        </el-table-column>
        <el-table-column label="剩余时效" align="center">
            <template #default="scope">
                <div>{{scope.row.type!='' ? scope.row.type : '/'}}</div>
            </template>
        </el-table-column>
        <el-table-column label="结余金额" align="center">
            <template #default="scope">
                <div>{{scope.row.price}}</div>
            </template>
        </el-table-column>
        <el-table-column label="时间范围" align="center" min-width="220">
            <template #default="scope">
                <div class="expire-time">{{scope.row.starttime+' ~ '+scope.row.endtime}}</div>
                <div class="expire-time">{{scope.row.isexpire ? '(有效)' : '(过期)'}}</div>
            </template>
        </el-table-column>
        <el-table-column label="最后操作时间" align="center">
            <template #default="scope">
                <div>{{scope.row.inputtime}}</div>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="180">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'记录'}" 
                    @finish="(val)=> {
                        this.logparam.view=true;
                        this.logparam.memberid=scope.row.memberid;
                    }"
                />
                <wcbutton class="left10" :option="{title:'退款',type:'del'}" 
                    @finish="(val)=> {
                        this.refundparam.view=true;
                        this.refundparam.memberid=scope.row.memberid;
                    }"
                />
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-select TTL-page-left" v-if="!param.ismember">
            <wcselect :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                :value="handlevalue"
                :list="handleinfos"
                @finish="(val)=> {
                    changehandle(val.value)
                }"
            />
        </div>
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



<!-- 会员vip续费记录 -->
<VipShow :view="logparam.view" :memberid="logparam.memberid" 
    @finish="(val) => {
        logparam.view=false;
        this.GetList();
    }" 
/>

<!-- 会员vip退款记录 -->
<VipRefund :view="refundparam.view" :memberid="refundparam.memberid"
    @finish="(val) => {
        refundparam.view=false;
        this.GetList();
    }"
/>

</template>

<script>
import INTERFACE_MODEL_VIP from '@/Interface/Es/vip';
import VipShow from '@/views/EsMembers/Module/VipShow';
import VipRefund from '@/views/EsMembers/Module/VipRefund';
export default {

    components:{
        VipShow,VipRefund
    },

    data() {
        return {
            objloading:'membervip',
            searchmember: {
                memberid:'',
                membername:'',
            },
            param: {
                ismember:false,
                memberid:'',
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],
            logparam: {
                view:false,
                memberid:'',
            },
            refundparam: {
                view:false,
                memberid:'',
            },

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                if(data.param.type=='selectmember') {
                    this.searchmember.memberid=data.param.data.id;
                    this.searchmember.membername=data.param.data.name;
                    this.param.memberid=data.param.data.id;
                    this.param.ischange=true;
                }
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var method=this.param.ismember? 'GET_VIP_DETAIL_LIST_FROM_MEMBER' : 'GET_MEMBER_VIP_LIST';
            INTERFACE_MODEL_VIP[method](this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
                 for(var i=0; i < this.list.length;i++) this.list[i].isshow=this.list[i].isshow==0? false : true;
            });
        },


        /** 修改上下架 **/
        ChangeShow(vipinfo) {
            var id=vipinfo.id;
            var isshow=vipinfo.isshow;
            isshow ? isshow=1 : isshow=0;
            INTERFACE_MODEL_VIP.CHANGE_SHOW({id:id,isshow:isshow}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },


        /** 修改排序 **/
        ChangeSort(id,sort) {
            INTERFACE_MODEL_VIP.CHANGE_SORT({id:id,sort:sort}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 删除设置 **/
        delVip(ids) {
            INTERFACE_MODEL_VIP.DEL_VIP({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 批量操作 **/
        changehandle(index) {
            var ids=this.GetSelectDataIds(); //获取当前选中的id
            if(ids.length==0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
            ids=ids.join(',');
            if(index==1) this.delVip(ids);    //批量删除
            if(index==2) this.$parent.JUMPVIEW({name:'EsEditVip',param:{id:ids}})
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isselect ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isselect=false;
            for(var i=0;i < val.length;i++) val[i].isselect=true;
            console.log(val);
        },
        

        /** 跳转搜索会员信息 **/
        searchmemberinfos() {
            this.$parent.JUMPVIEW({name:'EsMembers',param:{childtype:'selectmember',rollbackobjname:'EsVip'}})
        },

    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.TTL-username {color:#666eeb;cursor: pointer;}
.TTL-username span {display: inline-block;width:100%;}
.expire-time {display: inline-block;width:100%;text-align: center;}
.active-time,.active-time span {display: inline-block;width:100%;}
</style>